import  { useContext, useState, useEffect } from 'react';
import axios from 'axios';
import "../../../index.css";
import { PrimaryButton } from '@fluentui/react/lib/Button';
import { TeamsFxContext } from "../../Context";
import * as microsoftTeams from "@microsoft/teams-js";

export function Knowledge() {
  const {userPrincipalName, accessToken} = useContext(TeamsFxContext);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const reactFunctionEndpoint= process.env.REACT_APP_FUNCTION_ENDPOINT;
  const [loading, setLoading] = useState(false);
  const [loadMoreVisible, setLoadMoreVisible] = useState(false);
  const knowlegeViewMoreURL = `${reactFunctionEndpoint}/api/getSettings?type=knowledge`;
  const [knowledgeURL, setKnowledgeURL] = useState("");
  const [accesstoken, setToken]= useState(null);
  
  useEffect(()=> {
        const fetchToken = async() =>{
        try{
            await microsoftTeams.app.initialize();
            const ssoToken =await microsoftTeams.authentication.getAuthToken();
            setToken(ssoToken);
        } catch (err){
            console.err("Token check error: ", err);
        }
        };
        fetchToken();
    },[]);

  //const message = "Apologies, the service is currently unavailable. Please try again later.";
/* 
  useEffect(() => {
    fetchData();
  }, []);
 */
  // useEffect(() => {
  const fetchData = async () => {
    if (searchTerm.trim() === '') {
      setSearchResults([]);
      setLoadMoreVisible(false);
      return;
    }
    setLoading(true);
    try {
      //console.log("Search Term:", searchTerm);

      const response = await fetch(`${reactFunctionEndpoint}/api/getServiceNowAPIData?type=kbarticle&inputvalue=${encodeURIComponent(searchTerm)}`,
                        {
                            method: "GET",
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${accesstoken}`,
                            },
                        }
                    );
      const resp_kb = await response.json();
      const kb_data = resp_kb.KB_Articles;

      //console.log("Search Results:", kb_data);
      setSearchResults(kb_data.slice(0, 4));
      if (kb_data.length > 4) {
        setLoadMoreVisible(true);
      }

    } catch (error) {
      console.error('Error fetching search results:', error);
    }
    setLoading(false);
  };
  // fetchData();
  // }, [searchTerm]);

  const openLink = (url) => {
    window.open(url, "_blank");
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      fetchData();
    }
  }

  useEffect(()=>{
          fetch(knowlegeViewMoreURL,
                        {
                            method: "GET",
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${accesstoken}`,
                            },
                        }
                    )
          .then((res)=>res.json())
          .then((data)=>{
              setKnowledgeURL(data.urlPath);
          })
          .catch((err)=>console.error("Error fetching env values: ", err));
  }, []);

  return (
    <div className="tabHeader">
      <p> How can we help? </p>
      <input
        className="searchBar"
        type="text"
        placeholder="Search the knowledge library and service orders in English."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        onKeyPress={handleKeyPress}
      />

      {loading && <p>Loading...</p>}
      <ul className="search-results">
        {searchResults && searchResults.map((val, key) => (
          <li key={key} className="search-result">
            <div className="result-title">{val.shortDescription}</div>
            <div className="result-body">
              <PrimaryButton className="DarkButton" onClick={() => openLink(val.articleURL)}>Open link</PrimaryButton>
            </div>
          </li>
        ))}
      </ul>
      {loadMoreVisible && (
        <div className="view_more_btn">
          <PrimaryButton className="DarkButton" onClick={() => openLink(`${knowledgeURL}${searchTerm}`)}>View More</PrimaryButton>
        </div>
      )}
    </div>
  );
}
